import { Text, Button, Box } from '@chakra-ui/react'
import { Link } from 'react-router'
import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'
import { NewsItem } from './NewsItem'
import { useApp } from '../../hooks/useApp'

export const NewsList = ({ news, showMoreLink }: { news: Array<AppInfoMessage>, showMoreLink: boolean }) => {
  const { app } = useApp()

  return (
    <>
      {news &&
        news.length > 0 &&
        news.map(msg => {
          return (
            <NewsItem
              key={msg.id}
              variant="list"
              tagLabel={msg.type}
              maxLines={1}
              showMoreButton={true}
              {...msg}
            />
          )
        })}

      {news &&
        news.length > 0 && showMoreLink &&
        <Box px={'1rem'} py={'0.5rem'}> {/* hard coded, než bude definovaný design */}
          <Link to={`/${app}/news`}>
            <Button type="button" variant="outline" size="sm">
              Více aktualit
            </Button>
          </Link>
        </Box>
      }

      {(news?.length ?? 0) === 0 &&
        <Text textAlign='center'>Žádné aktuality k zobrazení</Text>
      }
    </>
  )
}